import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryLoyaltyDiscount.js';
import { RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { FIDELTOUR_CODE } from '@synergycms_app/store/customer/loyaltyActions';
import Price from '@synergycms_core/components/generic/Price';

const AvailMainSideSummaryLoyaltyDiscount = class AvailMainSideSummaryLoyaltyDiscount extends React.Component {
  static displayName = 'AvailMainSideSummaryLoyaltyDiscount';

  render() {
    const { config, theme } = this.props,
      {
        loyaltyDiscount,
        loyaltyUser,
        loyalty,
        stepCode,
      } = config;

    const { classes } = theme.styles;
    const cx = theme.bind();

    return (
      <div className={classes.contentModuleRow}>
        <div className={[classes.contentModuleCell, classes.large, classes.contentModuleCellTitle].join(' ')}>
          <RichText 
            text={loyalty?.get('code') !== FIDELTOUR_CODE ? '_%tarifa Star Traveler%_' : '_%tarifa%_'} 
            translate={true}
            innerStyle={['roboto15BoldBlack', 'capitalize', classes.stDefault, classes.starDiscount]}
          />
          {' '}
          {loyalty?.get('code') === FIDELTOUR_CODE && 
            <RichText
              text={(loyaltyUser && loyaltyUser.getIn(['current', 'tier'])) || loyalty.get('tier') || ''}
              translate={true} 
              ucFirst={true} 
              innerStyle={['roboto15BoldBlack', 'uppercase', 'mainColor', classes.starDiscount]}
            />
          }
        </div>
        <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
          <Price
            innerStyle={['summaryPriceMedium', classes.loyaltyPrice, classes.priceNumbers, classes.discountPrice, cx({stDefault: loyalty?.get('code') !== FIDELTOUR_CODE })]}
            amount={loyaltyDiscount}
            forceHotelCurrency={stepCode === 'confirmation'}
          />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (store, ownProps) => {
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);
  
  return {
    stepCode: stepCode,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, []),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'loyaltyDiscount',
    'loyaltyUser',
    'loyalty',
    'stepCode',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryLoyaltyDiscount);
